var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorcyclePinPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 32,
    viewBox: "0 0 18 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17H10V31C10 31.5523 9.55228 32 9 32C8.44772 32 8 31.5523 8 31V17Z",
    fill: "#747A7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9Z",
    fill: "#392e69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24806 13.084C5.06406 13.084 4.92006 13.032 4.81606 12.928C4.72006 12.824 4.67206 12.68 4.67206 12.496V5.044C4.67206 4.852 4.72406 4.708 4.82806 4.612C4.93206 4.508 5.07206 4.456 5.24806 4.456C5.41606 4.456 5.54406 4.488 5.63206 4.552C5.72806 4.608 5.81606 4.712 5.89606 4.864L9.04006 10.732H8.66806L11.8001 4.864C11.8801 4.712 11.9641 4.608 12.0521 4.552C12.1401 4.488 12.2681 4.456 12.4361 4.456C12.6121 4.456 12.7481 4.508 12.8441 4.612C12.9401 4.708 12.9881 4.852 12.9881 5.044V12.496C12.9881 12.68 12.9401 12.824 12.8441 12.928C12.7561 13.032 12.6201 13.084 12.4361 13.084C12.2521 13.084 12.1121 13.032 12.0161 12.928C11.9201 12.824 11.8721 12.68 11.8721 12.496V6.304H12.1361L9.35206 11.452C9.28806 11.572 9.22006 11.66 9.14806 11.716C9.07606 11.772 8.97606 11.8 8.84806 11.8C8.72006 11.8 8.61606 11.772 8.53606 11.716C8.45606 11.652 8.38406 11.564 8.32006 11.452L5.51206 6.292H5.80006V12.496C5.80006 12.68 5.75206 12.824 5.65606 12.928C5.56806 13.032 5.43206 13.084 5.24806 13.084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcyclePinPurple);
export default __webpack_public_path__ + "static/media/motorcyclePinPurple.fba3ae2b455df584fec313a62e95fc17.svg";
export { ForwardRef as ReactComponent };